import React from "react";
import BaseComponent from "../BaseComponent.js";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex";
import Type from "../Global/Typography.js";

import searchService from "../../services/SearchService.js";

import Modal from "../Global/Modal.js";
import PasswordManagementModal from "../Micro/PasswordManagementModal.js";

//IMAGES
import { ReactComponent as NotaSimple } from "./../../images/notaSimple.svg";
import { ReactComponent as Glance } from "./../../images/glanceNav.svg";
import { ReactComponent as UserIcon } from "../Global/Icons/user.svg";
import { ReactComponent as FlagGB } from "../Global/Icons/flagGB.svg";
import { ReactComponent as FlagCN } from "../Global/Icons/flagCN.svg";
import { ReactComponent as ArrowUp } from "../Global/Icons/arrowUp.svg";
import { ReactComponent as ArrowDown } from "../Global/Icons/arrowDown.svg";
import { ReactComponent as Vip } from "../Global/Icons/vip.svg";
import { ReactComponent as AudienceBoosters } from "../Global/Icons/audienceBoosters.svg";
import { ReactComponent as LatestProgrammes } from "../Global/Icons/latestProgrammes.svg";
import { ReactComponent as UpcomingProgrammes } from "../Global/Icons/upcomingProgrammes.svg";
import { ReactComponent as Favorite } from "../Global/Icons/favCrown.svg";
import { ReactComponent as SavedSearches } from "../Global/Icons/savedSearches.svg";

const StyledMenuMobile = styled(NanoFlex)`
  display: ${(props) => (props.visible ? "flex" : "none")};
  position: fixed;
  z-index: 9;
  left: 0;
  top: 0;
  width: 100vw;
  height: calc(100vh - 42px);
  background-color: ${nota.color.neutral.NeuFour};
  user-select: none;
  overflow: auto;
  .menuWrapper {
    .headerMenu {
      height: auto;
      min-height: -webkit-fit-content;
      background-color: ${nota.color.neutral.white};
      .logosWrapper {
        padding: 24px;
        border-bottom: 1px solid ${nota.color.neutral.NeuFive};
        .asideLogoWrapper {
          width: auto;
          svg {
            height: 28px;
            width: auto;
          }
          .logoNota {
            path {
              fill: ${nota.color.main.default};
            }
          }
        }
      }
      .accountDropdownWrapper {
        min-height: -webkit-fit-content;
        .accountDropdown {
          padding: 16px 24px;
          border-bottom: 1px solid ${nota.color.neutral.NeuFive};
          cursor: pointer;
          .titleDropDownWrapper {
            .iconWrapper {
              width: 20px;
              svg {
                height: 18px;
                width: auto;
                path {
                  fill: ${nota.color.neutral.NeuOne};
                }
              }
            }
            .titleWrapper {
              margin-left: 16px;
            }
          }
          .iconDropdownWrapper {
            width: auto;
            cursor: pointer;
            svg {
              height: 10px;
              width: auto;
              path {
                fill: ${nota.color.main.default};
              }
            }
          }
        }
        .expanderAccount {
          padding: 8px 0;
          a {
            width: 100%;
            text-decoration: none;
          }
          .secondaryItem {
            padding: 8px 24px 8px 60px;
            cursor: pointer;
            a {
              text-decoration: none;
            }
          }

          .activeItem {
            p {
              font-weight: bold;
              color: ${nota.color.main.default};
            }
          }

          .specialItem {
            border-top: 1px solid ${nota.color.neutral.NeuFive};
            padding: 16px 24px 8px 24px;
            margin-top: 8px;
            p {
              color: ${nota.color.main.mOne};
              text-transform: uppercase;
            }
          }
        }
      }
    }
    .listMenuWrapper {
      height: auto;
      .listMenu {
        height: auto;
        border-bottom: 1px solid ${nota.color.neutral.NeuFive};
        margin-top: 8px;
        padding-bottom: 8px;
        a {
          width: 100%;
          text-decoration: none;
        }
        .listItem {
          height: auto;
          cursor: pointer;
          padding: 8px 24px;

          .iconWrapper {
            width: 20px;
            svg {
              height: 18px;
              width: auto;
              path {
                fill: ${nota.color.neutral.NeuOne};
              }
            }
          }
          .titleWrapper {
            margin-left: 16px;
          }
        }
        .activeItem {
          .iconWrapper {
            svg {
              path {
                fill: ${nota.color.main.default};
              }
            }
          }
        }
      }
      .simpleMenu {
        .simpleItem {
          .titleWrapper {
            margin-left: 0;
          }
        }
        .activeItem {
          p {
            font-weight: bold;
            color: ${nota.color.main.default};
          }
        }
      }
      .headerNav {
        margin-top: 0px;
        .navFavHeader {
          height: auto;
          margin-bottom: 8px;
          padding: 8px 24px;
          background-color: ${nota.color.neutral.NeuFive};
          user-select: none;
          p {
            text-transform: uppercase;
            font-size: 12px;
          }
          svg {
            height: 14px;
            width: auto;
            path {
              fill: ${nota.color.main.mThree};
            }
          }
        }
      }
    }

    .languageOptionWrapper {
      height: auto;
      padding: 24px;
      .languageOption {
        cursor: pointer;
        padding: 8px 4px;
        background-color: ${nota.color.neutral.lightGrey};
        margin-right: 8px;
        svg {
          height: 35px;
          width: auto;
          path {
            fill: ${nota.color.neutral.NeuTwo};
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
      .languageActive {
        pointer-events: none;
        background-color: ${nota.color.main.default};
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }
  }
`;

export default class MenuMobile extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      expandAccount: false,
      showPasswordManagement: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  changeLanguage = (langId) => {
    window.dispatchEvent(new CustomEvent("languageChange", { detail: langId }));
  };

  toggleExpandAccount = () => {
    this.setState({ expandAccount: !this.state.expandAccount });
  };

  onPasswordManagementClick = () => {
    this.setState({ showPasswordManagement: true });
  };

  render() {
    let langId = this.getLanguage();

    return (
      <StyledMenuMobile className="menuMobile" visible={this.props.visible}>
        <NanoFlex className="menuWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="headerMenu" flexDirection="column">
            <NanoFlex className="logosWrapper" justifyContent="space-between">
              <NanoFlex className="asideLogoWrapper">
                <Link to="/" onClick={this.props.closeMenuMobile}>
                  <NotaSimple className="logoNota" />
                </Link>
              </NanoFlex>
              <NanoFlex className="asideLogoWrapper">
                <a href="https://www.glance-mediametrie.com/" rel="noopener noreferrer" target="_blank">
                  <Glance />
                </a>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="accountDropdownWrapper" flexDirection="column" justifyContent="space-between">
              <NanoFlex className="accountDropdown" onClick={this.toggleExpandAccount}>
                <NanoFlex className="titleDropDownWrapper">
                  <NanoFlex className="iconWrapper">
                    <UserIcon />
                  </NanoFlex>
                  <NanoFlex className="titleWrapper" justifyContent="flex-start">
                    <Type.p>
                      <b>My Account</b>
                    </Type.p>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="iconDropdownWrapper">
                  {!this.state.expandAccount && <ArrowDown />}
                  {this.state.expandAccount && <ArrowUp />}
                </NanoFlex>
              </NanoFlex>
              {this.state.expandAccount && (
                <NanoFlex className="expanderAccount" flexDirection="column" justifyContent="flex-start">
                  <Link to="/mySubscription" onClick={this.props.closeMenuMobile}>
                    <NanoFlex className={`secondaryItem ${this.props.render.match.path === "/mySubscription" && !this.props.selectedMenu ? "activeItem" : ""}`} justifyContent="flex-start">
                      <Type.p>{this.translation.myCompanySubscription.title}</Type.p>
                    </NanoFlex>
                  </Link>

                  <NanoFlex className="secondaryItem" justifyContent="flex-start" onClick={this.onPasswordManagementClick}>
                    <Type.p>{this.translation.passwordManagement.title}</Type.p>
                  </NanoFlex>

                  <Link to="/login" onClick={this.props.closeMenuMobile}>
                    <NanoFlex className="secondaryItem specialItem">
                      <Type.p>
                        <b>{this.translation.header.logOut}</b>
                      </Type.p>
                    </NanoFlex>
                  </Link>
                </NanoFlex>
              )}
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="listMenuWrapper" flexDirection="column">
            {/* MAIN LIST */}
            <NanoFlex className="listMenu" flexDirection="column">
              {/* NOTA SELECTION */}
              <NanoFlex
                className={`listItem ${this.props.selectedMenu === "NotaSelection" ? "activeItem" : ""}`}
                onClick={() => {
                  if (this.props.selectedMenu !== "NotaSelection") {
                    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "NotaSelection" } }));
                  }
                }}>
                <NanoFlex className="iconWrapper">
                  <Vip />
                </NanoFlex>
                <NanoFlex className="titleWrapper" justifyContent="flex-start">
                  <Type.p>
                    <b>{this.translation.navBar.notaSelection}</b>
                  </Type.p>
                </NanoFlex>
              </NanoFlex>

              {/* AUDIENCE BOOSTER */}
              <NanoFlex
                className={`listItem ${this.props.selectedMenu === "AudienceBooster" ? "activeItem" : ""}`}
                onClick={() => {
                  if (this.props.selectedMenu !== "AudienceBooster") {
                    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "AudienceBooster" } }));
                  }
                }}>
                <NanoFlex className="iconWrapper">
                  <AudienceBoosters />
                </NanoFlex>
                <NanoFlex className="titleWrapper" justifyContent="flex-start">
                  <Type.p>
                    <b>{this.translation.navBar.audienceBoosters}</b>
                  </Type.p>
                </NanoFlex>
              </NanoFlex>

              {/* LATEST PROGRAMMES */}
              <NanoFlex
                className={`listItem ${this.props.selectedMenu === "Latest" ? "activeItem" : ""}`}
                onClick={() => {
                  if (this.props.selectedMenu !== "Latest") {
                    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Latest" } }));
                  }
                }}>
                <NanoFlex className="iconWrapper">
                  <LatestProgrammes />
                </NanoFlex>
                <NanoFlex className="titleWrapper" justifyContent="flex-start">
                  <Type.p>
                    <b>{this.translation.navBar.latestProgrammes}</b>
                  </Type.p>
                </NanoFlex>
              </NanoFlex>

              {/* UPCOMING PROGRAMMES */}
              <NanoFlex
                className={`listItem ${this.props.selectedMenu === "Upcoming" ? "activeItem" : ""}`}
                onClick={() => {
                  if (this.props.selectedMenu !== "Upcoming") {
                    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Upcoming" } }));
                  }
                }}>
                <NanoFlex className="iconWrapper">
                  <UpcomingProgrammes />
                </NanoFlex>
                <NanoFlex className="titleWrapper" justifyContent="flex-start">
                  <Type.p>
                    <b>{this.translation.navBar.upcomingProgrammes}</b>
                  </Type.p>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>

            {/* LIST SAVED SEARCHS*/}
            {this.props.savedSearches?.length > 0 && (
              <NanoFlex className="listMenu headerNav" flexDirection="column">
                <NanoFlex className="navFavHeader" title={this.translation.navBar.favorites} justifyContent="space-between">
                  <Type.p>{this.translation.navBar.favorites}</Type.p>
                  {/* <Favorite /> */}
                </NanoFlex>
                <NanoFlex className="listContainer" flexDirection={"column"} alignItems={"flex-start"}>
                  {this.props.savedSearches?.map((item) => {
                    return (
                      <NanoFlex
                        key={"savedSearches_" + item.id}
                        title={item.searchName}
                        className={`listItem ${this.props.selectedMenu === "SavedSearch" && item.id === this.props.savedSearchId ? "activeItem" : ""}`}
                        justifyContent={"flex-start"}
                        onClick={(e) => {
                          window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { id: item.id, menu: "SavedSearch", lastCall: item.lastCall, filter: JSON.parse(JSON.stringify(item.filter)) } }));
                        }}>
                        <NanoFlex className="iconWrapper">
                          <SavedSearches />
                        </NanoFlex>
                        <NanoFlex className="titleWrapper" justifyContent="flex-start">
                          <Type.p>
                            <b>{item.searchName}</b>
                          </Type.p>
                        </NanoFlex>
                      </NanoFlex>
                    );
                  })}
                </NanoFlex>
              </NanoFlex>
            )}
            {/* LIST SIMPLE*/}
            <NanoFlex className="listMenu simpleMenu" flexDirection="column">
              {/* FAQ */}
              <Link to="/faq" onClick={this.props.closeMenuMobile}>
                <NanoFlex className={`listItem simpleItem ${this.props.render.match.path === "/faq" && !this.props.selectedMenu ? "activeItem" : ""}`} justifyContent="flex-start">
                  <NanoFlex className="titleWrapper" justifyContent="flex-start">
                    <Type.p>{this.translation.faq.title}</Type.p>
                  </NanoFlex>
                </NanoFlex>
              </Link>

              {/* ABOUT US */}
              <Link to="/aboutUs" onClick={this.props.closeMenuMobile}>
                <NanoFlex className={`listItem simpleItem ${this.props.render.match.path === "/aboutUs" && !this.props.selectedMenu ? "activeItem" : ""}`} justifyContent="flex-start">
                  <NanoFlex className="titleWrapper" justifyContent="flex-start">
                    <Type.p>{this.translation.aboutUs.title}</Type.p>
                  </NanoFlex>
                </NanoFlex>
              </Link>
            </NanoFlex>
          </NanoFlex>

          {/* LANGUAGE */}
          <NanoFlex className="languageOptionWrapper">
            <NanoFlex className={`languageOption ${langId === null ? "languageActive" : ""}`} onClick={() => this.changeLanguage(null)}>
              <FlagGB />
            </NanoFlex>
            <NanoFlex className={`languageOption ${langId === 1 ? "languageActive" : ""}`} onClick={() => this.changeLanguage(1)}>
              <FlagCN />
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>

        <Modal show={this.state.showPasswordManagement} content={<PasswordManagementModal cancelAction={() => this.setState({ showPasswordManagement: false })} nextAction={() => this.setState({ showPasswordManagement: false })} />} />
      </StyledMenuMobile>
    );
  }
}
